document.addEventListener("DOMContentLoaded", function () {
  const parentDiv = document.querySelector(".pdp-swiper");
  const nextButton = parentDiv.querySelector(
    '[data-swiper-button-next="pdp-swiper"]'
  );
  const prevButton = parentDiv.querySelector(
    '[data-swiper-button-prev="pdp-swiper"]'
  );

  var swiper = new Swiper(".pdp-nav-swiper", {
    spaceBetween: 24,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  var swiper2 = new Swiper(".pdp-swiper", {
    spaceBetween: 10,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    pagination: {
      el: parentDiv.querySelector(".pdp-gallery-dots"),
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
    thumbs: {
      swiper: swiper,
    },
  });

  initGalleryHints(parentDiv, swiper2, swiper);

  // Handle quantity selector "more" option
  const quantitySelect = document.querySelector('.js-quantity-control-input');

    quantitySelect.addEventListener('change', function() {

      if (this.value === 'more') {
        // Create a new number input
        const numberInput = document.createElement('input');
        numberInput.type = 'number';
        numberInput.name = 'quantity';
        numberInput.value = '11';
        numberInput.min = '1';
        numberInput.className = this.className;
        numberInput.setAttribute('aria-label', 'Quantity');

        // Replace the select with the number input
        this.parentNode.replaceChild(numberInput, this);
      }
    });

});


/*
 * YAR-399: make it obvious that a product has more photos. The last fully
 * visible thumbnail turns into a "+N foto's" tile while thumbnails are hidden
 * to the right of it (bol.com/Coolblue pattern).
 */
function initGalleryHints(mainEl, main, thumbs) {
  if (!mainEl || !main) return;

  const thumbsEl = thumbs && thumbs.el;
  if (!thumbsEl || thumbs.slides.length < 2) return;

  // Keep the active thumbnail in view with one neighbour on each side, but
  // only move the strip when the active one reaches an edge (so it never
  // shifts under the cursor while clicking a visible thumbnail).
  const perView = Math.floor(Number(thumbs.params.slidesPerView)) || 4;
  const visibleRange = () => {
    let first = -1;
    let last = -1;
    thumbs.slides.forEach((slide, i) => {
      if (slide.classList.contains("swiper-slide-fully-visible")) {
        if (first < 0) first = i;
        last = i;
      }
    });
    return { first, last };
  };
  let firstShown = 0;
  thumbs.on("setTranslate", () => {
    const { first } = visibleRange();
    if (first >= 0) firstShown = first;
  });
  const keepActiveInView = () => {
    const n = thumbs.slides.length;
    const active = main.activeIndex;
    const maxFirst = Math.max(0, n - perView);
    let target = firstShown;
    if (active >= firstShown + perView - 1) target = active - perView + 2;
    else if (active <= firstShown) target = active - 1;
    target = Math.min(maxFirst, Math.max(0, target));
    // Run after Swiper's own thumbs sync, which may have scrolled already.
    requestAnimationFrame(() => thumbs.slideTo(target));
  };
  main.on("slideChange", keepActiveInView);

  const label = thumbsEl.dataset.moreLabel || "";
  const more = document.createElement("span");
  more.className = "pdp-thumb-more";
  more.setAttribute("aria-hidden", "true");
  more.innerHTML =
    '<span class="pdp-thumb-more__count"></span><span class="pdp-thumb-more__label"></span>';
  more.querySelector(".pdp-thumb-more__label").textContent = label;
  const moreCount = more.querySelector(".pdp-thumb-more__count");

  let frame = 0;
  const placeMore = () => {
    frame = 0;
    // While the strip animates, leave the tile where it is (it slides along)
    // and settle it on transitionEnd; only clear it off the shown photo.
    if (thumbs.animating) {
      const holder = more.parentNode;
      if (holder && thumbs.slides.indexOf(holder) === main.activeIndex) {
        holder.removeChild(more);
      }
      return;
    }
    const slides = thumbs.slides;
    let lastVisible = -1;
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains("swiper-slide-fully-visible")) {
        lastVisible = i;
      }
    }
    const hiddenAfter = slides.length - 1 - lastVisible;
    const target = slides[lastVisible];
    // Never cover the photo that is currently shown.
    if (
      lastVisible < 0 ||
      hiddenAfter < 1 ||
      lastVisible === main.activeIndex
    ) {
      if (more.parentNode) more.parentNode.removeChild(more);
      return;
    }
    moreCount.textContent = "+" + (hiddenAfter + 1);
    if (more.parentNode !== target) target.appendChild(more);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(placeMore);
  };

  ["setTranslate", "resize", "slidesUpdated", "transitionEnd"].forEach((e) =>
    thumbs.on(e, schedule)
  );
  main.on("slideChange", schedule);
  schedule();
}
